import { GenerateQuotePdfDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { downloadBlob } from 'modules/core/lib/download'
import { handleResult } from 'modules/core/lib/handleMutation'

import handleResultWithFlash from 'modules/finance/lib/handleResultWithFlash'

export function useDownloadQuotePdf() {
  const { company } = useCurrentSession()
  const [generateQuotePdf] = useMutation(GenerateQuotePdfDocument, {
    extractorFn: (data) => data.financeMutations.generatePdfFinanceQuotePdf,
  })

  return async (quoteId: string) => {
    const result = await generateQuotePdf({
      variables: {
        id: quoteId,
        companyId: company.id,
      },
    })

    const handled = handleResult(result, handleResultWithFlash())

    if (handled.success) {
      if (!handled.data.quotePdf) return
      const base64File = handled.data.quotePdf.rawPdfBase64

      const fileResponse = await fetch(
        `data:application/pdf;base64,${base64File.replace(/^data:.*,/, '')}`
      )

      const blob = await fileResponse.blob()
      downloadBlob(blob, handled.data.quotePdf.filename)
      track(trackingEvents.accounting.quotes.downloadPdf)
    }
  }
}
